export class RSF {

      public rsfId: number;     //*RSF_ID #10
      public paymentDate: Date; // PAYMENT_DATE // SYSDATE in service
      //--------------------------------------------------------------
      public status: number;   //*STATUS #3      @1: RSF_STORED
      public batchId: number;  //*BATCH_ID #10   @2: RSF_PRIORITY_URGENT
      public priority: number; // PRIORITY #3
 
      public serviceRequests: ServiceRequest[] = new Array<ServiceRequest>();
      public payment: PaymentVO;  ////// = new Payment();

      public captcha:string;        // return from google.
      public contextRoot:string;    // nrs
 }
 
 export class ServiceRequest {
 
      public serviceRequestId: number;      //*SERVICE_REQUEST_ID #10
      public rsfId: number;                 //*RSF_ID #10
      public applicantId: number;           // APPLICANT_ID #10
      //--------------------------------------------------------------
      public serviceRequestSeq: number;     // SERVICE_REQUEST_SEQ #5        @from 1 to 5
      public serviceType: number;           //*SERVICE_TYPE #5               @0 or 134
      public subjectName: string;           //*SUBJECT_NAME #250             @no middle name, lastName, firstName
      public status: number;                //*STATUS #3                     @2: default  from mapping default
      public serviceLanguage: string;       // SERVICE_LANGUAGE #1           @E or F
      public source: string;                // SOURCE #1                     @I
      public eventDate:string;              // EVENT_DATE : Date             @Child Birth Day

      // -------- fixed -----------------
      public applicant: ApplicantVO = new ApplicantVO();  // ContactInfo
      public guarantorInfo: GuarantorInfoVO;                    /// = new GuarantorInfo();
      public productRequests: ProductRequestVO[] = new Array<ProductRequestVO>();

      //---------  optional ------
      public birthCertificateReq: BirthCertificateRequestVO;    /// = new BirthCertificateRequest();
      public slbRequest: SLBRequestVO;                          /// = new SLBRequest();
      public cesp:Cesp;

      public nlbRequest: NLBRequestVO;                                /// = new NLBRequest();
      public deathCertificateReq: DeathCertificateRequestVO;          /// = new DeathCertificateReq();
      public marriageCertificateReq: MarriageCertificateRequestVO;    /// = new DeathCertificateReq();
 }
 
  

export class ApplicantVO {
      public ApplicantID: number; 
      //-------------------------------------------------
      public surname: string;                        // Which parent is applicant? based on logic for BR or BC
      public givenName: string;
      //-------------------------------------------------
      public streetNumber: string;                   // contact.address
      public streetName: string;

      public apartmentNumber: string;
      public buzzerNumber: string;
      public poBox: string;                    // address.deliveryMode + deliverAddr or poBox for international

      public city: string;
      public provinceCode: number;
      public countryCode: number;
      public otherCountry: string;

      public postalCode: string;

      //-------------------------------------------------
      public phoneNumber: string;
      public phoneExt: string;
      public dayTimePhoneNumber: string;
      public dayTimePhoneExt: string;
      //-------------------------------------------------
      public language: string;                    // same Lang as ServiceRequestVO
      public organizationName: string;            // OrderOfBC.organizationForOther

      public emailAddress: string;                // not.used.
}


//================================================================================================
export class SLBRequestVO {
      public serviceRequestId: number;

      //-------------------------------------------------------------------------------
      public childSurname: string;        // or SingleName
      public childGivenName: string;
      public childMiddleName: string;
      public lastNameAgreement: string;   // $Test-31 : child.isParentAgreeOnLastName or isParentAgreeOnSingleName

      public childSex: string;            // @child.gender
      public dateOfEvent: string;         // @child.birthDay;
      //-------------------------------------------------------------------------------
      public eventPlaceType: string;      // $Test-32 : H(hospital) , H(BirthCenter?)  , R(Home), O(Other)
      public hospitalName: string;        // $Test-33 : @child.birthPlaceName by code or @child.otherBirthPlace or street numb+name

      public poeCity: string;             // @child.cityName;
      public poeCounty: string;           // @child.region;

      public hospitalCode: string;        // $Test-34-1:lookup.test  @facility.facilityCode
      public poePostalCode: string;       // $Test-34-2:lookup.test  @facility.postalCode;

      public poeStName: string;           // @facility.streetNumber   or Home/Other input values
      public poeStNumber: string;         // @facility.streetName     or Home/Other input values

      public poeCityGeocode: number;      //  $Test-35:  lookup by child.cityName
      public poeOtherAddDetail: string;   //  @same as hospitalName for Other
      //-------------------------------------------------------------------------------
      public birthSequence: number;        // input index 1 to 5
      public birthType: number;            // 1 to 56 2: twin 3:triple

      public childrenLiveborn: number;
      public childrenStillborn: number;
      public childrenBorn: number;          // childrenLiveborn + childrenStillborn

      public weightOfChildGram:  number;    // $Test-36 : empty for Pound?
      public weightOfChildPound: number;    // $Test-36 : convert check : ounce/16 + pounds : Decimal 2?
      //-------------------------------------------------------------------------------
      public attendantDesignation: string;       // @child.attendentType;
      public attendantDesignationOther: string;  // @child.attendentTitle; 
      public attendantGivenName: string;         // @child.attendentFirstName;
      public attendantSurname: string;           // child.attendent/Single/Last/Name;


      public otherInformantCertPresent: string = "N";   // $Test-37 : (eligibility.isOtherCertifyingBirth) if other sign "Y" or "N"
      public informantGivenName: string;                 
      public informantSurname: string;
      public organizationInformantName: string;         // same as applicant's organizationName : it is from OrderOfBC

      public typeOfInformant: string =  null;           // always null

      //----------------------------------------------------
      public motherParentType: number;
      public isMotherLastNameAgreed: boolean;   // $Test-38  @mother.isLastNameAgreed  --> check this value is set correctly.
      public motherCertPresent: string;         // $Test-39  --> check if unableToCertify

      public motherAge: number;
      public motherDateOfBirth: string;
      public motherMaritalStatus: string;
      public gestationPeriod: number;   // 2parent.pregnancyDuration;

      public motherDayPhoneNumber: string;  
      public motherMailPhoneNumber: string; 

      public motherGivenName: string;
      public motherMiddleName: string;
      public motherSurname: string;
      public motherMaidenName: string;
      public motherOtherSurname: string;

      public motherPobCity: string;          // @placeOfBirth.city

      public motherPobCountryCode: number;   // $Test-40-1  also province code if canada or null for NotFound(-2)
      public motherPobCountry: string;       // $Test-40-2  1:Ontario,Canada 2:Korea  3:OtherCountryName
                                             // $Test with Father/Parent3,4
      //----------------------------------------------------------------------------
      // mail.address  : sameInd(Y)  MailAddr = emtpy(same as Res Addr) : ResAddr = ContactAddr 
      //                 saneInd(N)  MailAddr = ContactAddr             : ResAddr = MotherAddr
      //----------------------------------------------------------------------------
      public motherMailAddSameInd: string = "N";

      public motherMailAddStNumber: string;
      public motherMailAddStName: string;

      public motherMailAddAptNumber: string;
      public motherMailBuzzerNumber: number;

      public motherMailAddCity: string;
      public motherMailCountry: string;           // $Test-41-1
      public motherMailCountryCode: number;       // $Test-41-2

      public motherMailDeliveryMode: string;      // $Test-42-1  : Canada deliveryAddr or International pobox : clear Check.
      public motherMailRouteNumber: string;       // $Test-42-2
      public motherMailPostalCode: string;




      //------------ res.address ------------------------
      public motherResStreetNumber: string;
      public motherResStreetName: string;

      public motherResAptNumber: string;

      public motherResCity: string;
      public motherResCountry: string;        // $Test-43-1
      public motherResCountryCode: number;    // $Test-43-2

      public motherResDeliveryMode: string;   // $Test-44-1
      public motherResRouteNumber: string;    // $Test-44-2

      public motherResPostalCode: string;
      public motherResGeocode: number;        // $Test-45

      //-----------------------------------------------------
      public poeOutOfProvince: string = "N";   // hard-coding

      //----------------------------------------------
      public fatherInfoPresentInd: string = "N";    // if father exists "Y" or "N"
      public fatherParentType: number;
      public isFatherLastNameAgreed: boolean;       // $Test-46  @mother.isLastNameAgreed  --> check this value is set correctly.
      public fatherCertPresent: string;             // $Test-47  --> check if unableToCertify

      public fatherAge: number;
      public fatherDateOfBirth: string;

      public fatherGivenName: string;
      public fatherMiddleName: string;
      public fatherOtherSurname: string;
      public fatherSurname: string;
      public fatherSurnameAtBirth: string;

      public fatherPobCity: string;                    // @placeOfBirth.city
      public fatherPobCountry: string;                 // $test with mother/parent3 
      public fatherPobCountryCode: number;             // $test with mother/parent3 

      //----------------------------------------------
      public isBirthSurrogate: string;                 // isBornThroughSurrogacy   Y or null
      public isNonHospitalLocation: string;            // deliveredByOther         Y or null
      public isIncapableOfCertifying: string;          // isUnableToCertify        Y or null
      public isOtherCertifying: string;                // isOtherCertifyingBirth   Y or null
      //----------------------------------------------
      public isTraditionalCulture: string;     //  hasSingleName
      
      //===============================================
      public adjudicationRequired: string  = 'N';
      public parent3InfoPresentInd: string = 'N';
      public parent4InfoPresentInd: string = 'N';
      public parent3: AdditionalParentInfoExtVO;
      public parent4: AdditionalParentInfoExtVO;
      public versionNumber: number =  1;    // 1 always
      //===============================================

      
      //------------------------------------
      public associatedNlbSrId: number;
      public bookYear: number;
      public modifiedBy: string;
      public modifyDate: string;
      public registrationNumber: number;

      //------------------------------------
      public motherOccupation: string;   // ?
      public culturalNamingInd: string = "N";     // 
      public religiousNamingInd: string = "N";    // 
      public ethnicNamingInd: string = "N";       // hard-coding

      public certificationIndicator: string = "Y";  // hard-coding
      public casCertificationPresent: string = "N"; // hard-coding
      public mailRegNotification: string = "N";     // hard-coding
}

export class AdditionalParentInfoVO {
      public parentType: number;

      public parentSurname: string;                    // @Test-20 : Not Last Name : Birth Name
      public parentGivenName: string;
      public parentMiddleName: string;
      public parentPreviousName: string;

      public parentAge: number;                        // @Test-21  : calcalated
      public parentDateOfBirth: string;
      public parentPlaceOfBirthCity: string;           // placeOfBirth.city
      public parentPlaceOfBirthCountry: number = -1;   // @Test-22   country or province for canada
      public parentPOBCountry: string;                 // @Test-23 empty & countryCode : PARENT?_POB_COUNTRY_OTHER
}

// Only For SLBRequest
export class AdditionalParentInfoExtVO extends AdditionalParentInfoVO {
      public parentNameAtBirth: string;
      public isCertificationPresent: boolean;
      public isLastNameAgreed: boolean;
}


export class BirthCertificateRequestVO {
      public serviceRequestID: number;
      public serviceType: number;

      public subjectSurname: string;
      public subjectMiddleName: string;
      public subjectGivenName: string;

      public subjectSex: string;
      public subjectDeceasedIndcator: string;
      //---------------------------------------------
      public subjectRelationship: number;    // @Test-1
      public dateOfBirth: string;
      public locationType: string;           // @Test-2 code convert
      public locationTypeOther: string;      // @Test-3 
      public placeOfEvent: string;           // child.cityName
      public weightOfChild: number;          // @Test-4  convert
      public nameOfHospital: string;         // @Test-5 child.birthPlaceName when 0 or 2
      //---------------------------------------------
      public motherParentType: number;
      public motherMaidenName: string;
      public motherSurname: string;
      public motherMiddleName: string;
      public motherPreviousSurname: string;   // @Test-6 combined name with SurName
      public motherGivenName: string;

      public motherMaritalStatus: string;
      public motherAge: number;               // @Test-7 : age calculation
      public motherDateOfBirth: string;
      public motherPlaceOfBirthCity: string;          // placeOfBirth.city
      public motherPlaceOfBirthCountry: number = -1;  // @Test-8  country or province for canada.
      public motherPOBCountry: string;                // @Test-9  placeOfBirth.otherCountry is empty & motherPlaceOfBirthCountry

      public motherSin: number;                       // @Test-10  CCB SIN : combined value

      //---------------------------------------------   // @Test-11  MotherAddress or ContactAddress
      public motherStreetNumber: string;
      public motherStreetName: string;
      public motherCity: string;
      public motherProvinceCountry: number;             // @Test-11-1 : country or province for canada.
      public motherProvinceCountryOther: string;        // @Test-11-2 : placeOfBirth.otherCountry is empty & motherPlaceOfBirthCountry
      public motherPostalCode: string;
      
      //---------------------------------------------
      public fatherInfoNotProvided: string = "N";        // ColumnName is misleading : Yes means father exists.
      public fatherParentType: number;

      public fatherSurname: string;                      //@Test-12  : Not Last Name : Birth Name
      public fatherGivenName: string;
      public fatherMiddleName: string;
      public fatherPreviousName: string;                 //@Test-13 : combined name

      public fatherAge: number;                          //@Test-14 : Calculated age
      public fatherDateOfBirth: string;

      public fatherPlaceOfBirthCity: string;             // parent.placeOfBirth.city
      public fatherPlaceOfBirthCountry: number = -1;     // @Test-15 :  provine or country code
      public fatherPOBCountry: string;                   // @Test-16 :  isEmtpy & countryCode : FATHER_POB_COUNTRY_OTHER

      //---------------------------------------------
      public ccbCareGiver: number;                       // @Test-17-1 check parentTitle by mapping.
      public notificationSinParent1:number;              // @TEST-17-2 check parentTitle by mapping.
      public notificationSinParent2:number;              // @TEST-17-3 check parentTitle by mapping.

      //---------------------------------------------
      public attendantDesignation: string;               // child.attendentType;
      public attendantFirstName: string;
      public attendantLastName: string;

      //---------------------------------------------
      public additionalParents: AdditionalParentInfoVO[];

      //---------------------------------------------
      public guarantorSignaturePresent: string;
      public guarantorInfoPresent: string;
      public guarantorValid: string;
      public previousFirstName1: string;
      public previousFirstName2: string;
      public previousMiddleName1: string;
      public previousMiddleName2: string;
      public previousLastName1: string;
      public previousLastName2: string;



      //------------------------------
      public dayTimeTelephoneNumber: string;       //  commented out in original SLB
      //------------------------------
      public outOfProvince: string;
      public childrenBorn: number; 
      public guarantorCitizenIndicator: string;
      public proofOfCustodyIndicator: string;
      public CorrespondenceSignedIndicator: string;
      public DOBUnknown: string;
      public proofOfdeathAttached: string;
      public requestReasonType: number;
      public otherRequestText: string;
      public applicantSignatureIndicator: string;
      public additionalInfoIndicator: string;
      public createDate: string;
      public modifyDate: string;
      public doctorAddress: string;

      public registrationID: number;
      public bookYear: number;
      public registrationNumber: number;
      public validFromIndicator: string;
      public prevCertificateIndicator: string;
      public prevParentalCertificateIndicator: string;
      public prevCertified: string;
      public prevNameChangeIndicator: string;
      public searchYearFrom: number;
      public searchYearTo: number;
}



export class NLBRequestVO {
      public serviceRequestId: number;
      public versionNumber: number;
      public adjudicationRequired: string;
      public associatedSlbSrId: number;
      public attendantDesignation: string;
      public attendantDesignationOther: string;
      public attendantGivenName: string;
      public attendantLicenceNumber: string;
      public attendantMailAddCity: string;
      public attendantMailAddCounty: string;
      public attendantMailAddProv: number;
      public attendantMailAddProvDesc: string;
      public attendantMailAddStName: string;
      public attendantMailAddStNumber: string;
      public attendantMailPostalCode: string;
      public attendantSignatureInd: string;
      public attendantSurname: string;
      public attendantTelephoneNumber: string;
      public birthSequence: number;
      public birthType: number;
      public bookYear: number;
      public certificationIndicator: string;
      public childLivebornInd: string;
      public childSex: string;
      public dateOfEvent: string;
      public eventPlaceType: string;
      public gestationPeriod: number;
      public hospitalCode: string;
      public hospitalName: string;
      public modifiedBy: string;
      public modifyDate: string;
      public motherAge: number;
      public motherDateOfBirth: string;
      public motherGivenName: string;
      public motherHealthCardNumber: number;
      public motherMaidenName: string;
      public motherMiddleName: string;
      public motherResAptNumber: string;
      public motherResCity: string;
      public motherResCountry: string;
      public motherResCountryCode: number;
      public motherResPostalCode: string;
      public motherResPoBox: string;
      public motherResStreetName: string;
      public motherResStreetNumber: string;
      public motherSurname: string;
      public motherTelephoneNumber: string;

      public poeStNumber: string;
      public poeStName: string;
      public poeAptNumber: string;

      public poeCity: string;
      public poeCityGeocode: number;

      public poeProv: number;
      public poeCounty: string;
      public poePostalCode: string;
      public poeOtherAddDetail: string;
      
      public previousLiveborn: number;
      public previousStillborn: number;
      public registrationNumber: number;
      public regAgentGivenName: string;
      public regAgentSurname: string;
      public weightOfChildGram: number;
      public weightOfChildPound: number;
}

export class MarriageCertificateRequestVO {
      public serviceRequestID: number;
      public registrationID: number;
      public bookYear: number;
      public registrationNumber: number;
      public serviceType: number;
      public groomSurname: string;
      public groomFirstName: string;
      public groomMiddleName: string;
      public brideSurname: string;
      public brideFirstName: string;
      public brideMiddleName: string;
      public marriageDate: string;
      public placeOfMarriage: string;
      public whoCanObtainInfo: number;
      public reasonToObtainInfo: number;
      public applicantSignatureIndicator: string;
      public startSearchYear: number;
      public endSearchYear: number;
      public validFormIndicator: string;
      public outOfProvince: string;
      public groomBirthProvCountry: number;
      public brideBirthProvCountry: number;
      public otherRelation: string;
      public proofOfAuthInd: string;
      public groomOtherLastName: string;
      public brideOtherLastName: string;
      public brideGroomDeceasedInd: string;
      public certificationByClosestKin: string;
      public otherReason: string;
      public correspondenceSigned: string;
      public groomBirthDate: string;
      public brideBirthDate: string;
}

export class DeathCertificateRequestVO {
      public serviceRequestID: number;
      public registrationID: number;
      public bookYear: number;
      public registrationNumber: number;
      public serviceType: number;
      public deceasedSurname: string;
      public deceasedMiddleName: string;
      public deceasedGivenName: string;
      public motherSurname: string;
      public motherMiddleName: string;
      public motherFirstName: string;
      public fatherSurname: string;
      public fatherFirstName: string;
      public fatherMiddleName: string;
      public parent3LastName: string;
      public parent3FirstName: string;
      public parent3MiddleName: string;
      public parent4LastName: string;
      public parent4FirstName: string;
      public parent4MiddleName: string;
      public deathDate: string;
      public birthDate: string;
      public placeOfDeath: string;
      public deceasedSex: string;
      public ageAtDeath: number;
      public maritalStatusAtDeath: string;
      public whoCanObtainInfo: number;
      public reasonToObtainInfo: number;
      public applicantSignatureIndicator: string;
      public searchYearFrom: number;
      public searchYearTo: number;
      public validFormIndicator: string;
      public outOfProvince: string;
      public ageRange: string;
      public proofOfAuthInd: string;
      public partnerLastName: string;
      public partnerFirstname: string;
      public partnerMiddleName: string;
      public otherRelationship: string;
      public otherReasonForRequest: string;
      public correspondenceSigned: string;
      public certificationByClosestKin: string;
}

export class GuarantorInfoVO {
      public GuarantorInfoID: number;
      public ServiceRequestID: number;
      public OccupationID: number;
      public LastName: string;
      public FirstName: string;
      public Organization: string;
      public RegistrationNumber: string;
      public DayPhoneNumber: string;
      public NightPhoneNumber: string;
      public FaxNumber: string;
      public StreetNumber: string;
      public StreetName: string;
      public City: string;
      public Province: number;
      public PostalCode: string;
      public YearsKnown: number;
      public GuarantorAuthorized: string;
      public ApartmentNumber: string;
}

export class PaymentVO {
      public paymentID: number;
      public paymentSeq: number;
      public paymentType: number;
      public rsfID: number;
      public rsfDocumentReceiptID: number;
      public currencyCode: string;
      public negotiable: number;
      public status: number;
      public amount: number;
      public allocationAmount: number;
      public voucherNumber: number;
      public receivedUserID: number;
      public supervisorUserID: number;
      public applicantName: string;
      public bodyAndFigures: number;
      public noSignatures: number;
      public inValidDate: number;
      public payeeIncorrect: number;
      public canFfundOnUSAccount: number;
      public noBankTranInfo: number;
      public signatureInd: string;
      public chequeReturnedInd: string;
      public creditCardNumber: number;
      public creditCardType: number;
      public expiryDate: string;
      public ccPaySessionNumber: number;
      public ccPayStatus: number;
      public authorizedAmount: number;
      public confirmationNumber: string;
      public nameOnCard: string;
      public ioBankName: string;
      public ioConfCode: string;
      public transactionNumber: string;
      public authorizationCode: string;
      public paymentDate: string;
}

export class ProductRequestVO {
      public serviceRequestID: number;
      public productCode: number;
      public serviceLevel: number;
      public numberItems: number;
      public status: number;
      public unpaidBalance: number;
}

export class Cesp {
      public status:string;

      public childGivenName:string;
      public childSurname:string;
      public childDateOfBirth:string; 
      
      public parentGivenName:string;
      public parentSurname:string;

      public parentPostalCode:string;
      public parentCountry:string;
      
      public phone1:string;
      public phone1Ext:string;  
      public phone1TTY:number;
      
      public phone2:string;
      public phone2Ext:string;
      public phone2TTY:number;
      
      public email:string;
      
      public financialOrganization:string;   // $Test-60  promoter code
      public contactLanguage:number;  
      public contactMethod:number;
      public contactTime:number;
      
      public rsfId:number;
      public seqNumber:number;
      public bundle:string;                  // $Test-61
      public consent:string;

      public emailForReceipt:string;
}
